<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_ads") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.contents')"
            @selectImage="selectImage"
            :acceptVideo="true"
            required
          />
          <!-- End:: Image Upload Input -->

          <!-- <BaseImageUploadInput @file-selected="handleFileSelected" @file-removed="handleFileRemoved" /> -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Region Input -->
          <!-- <base-select-input
            col="6"
            :optionsList="regions"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model="data.region"
            required
          /> -->
          <!-- End:: Region Input -->

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            required
          />

          <!-- End:: Name Input -->

          <!-- Start:: Link Type Selection -->
          <base-select-input
            col="12"
            :optionsList="linkTypes"
            :placeholder="$t('PLACEHOLDERS.linkType')"
            v-model="data.linkType"
          />
          <!-- End:: Link Type Selection -->

          <!-- {{ data.linkType }} -->
          <!-- Start:: External Link Input -->
          <template v-if="data.linkType && data.linkType.id === 'external'">
            <base-input
              col="12"
              type="text"
              :placeholder="$t('PLACEHOLDERS.externalUrl')"
              v-model.trim="data.externalUrl"
            />
          </template>
          <!-- End:: External Link Input -->

          <!-- Start:: Internal Link Options -->
          <template v-if="data.linkType && data.linkType.id === 'internal'">
            <!-- URL Type Selection -->
            <base-select-input
              col="6"
              :optionsList="urlTypes"
              :placeholder="$t('PLACEHOLDERS.urlType')"
              v-model="data.urlType"
              @input="onUrlTypeChange"
            />

            <!-- Item Selection -->
            <base-select-input
              v-if="data.urlType"
              col="6"
              :optionsList="items"
              :placeholder="$t('PLACEHOLDERS.selectItem')"
              v-model="data.selectedItem"
            />
          </template>
          <!-- End:: Internal Link Options -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "CreateAds",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        region: null,
        linkType: null, // internal or external
        externalUrl: null,
        urlType: null, // category or salon
        selectedItem: null,
      },
      // End:: Data Collection To Send
      regions: [],
      linkTypes: [
        { id: "external", name: "رابط خارجي", name_en: "External Link" },
        { id: "internal", name: "رابط داخلي", name_en: "Internal Link" },
      ],
      urlTypes: [
        { id: "category", name: "قسم", name_en: "Category" },
        { id: "salon", name: "صالون", name_en: "Salon" },
      ],
      items: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {},

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    async onUrlTypeChange() {
      this.data.selectedItem = null;
      this.items = [];
      if (this.data.urlType) {
        if (this.data.urlType.id === "category") {
          await this.getCategories();
        } else if (this.data.urlType.id === "salon") {
          await this.getSalons();
        }
      }
    },

    async getCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories`,
          params: {
            ignorePermissionCheck: 1,
            page: 0,
            limit: 0,
            isActive: 1,
          },
        });
        this.items = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getSalons() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `salons`,
          params: {
            ignorePermissionCheck: 1,
            page: 0,
            limit: 0,
            isActive: 1,
          },
        });
        this.items = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.publish_start_date) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.startDate"));
        return;
      } else if (!this.data.publish_end_date) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.endDate"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            ignorePermissionCheck: 1,
            page: 0,
            limit: 0,
            isActive: 1,
          },
        });
        this.regions = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("name[ar]", this.data.nameAr);

      REQUEST_DATA.append("name[en]", this.data.nameEn);

      if (this.data.image.file) {
        REQUEST_DATA.append("file", this.data.image.file); // Append the file to the FormData
        // REQUEST_DATA.append("image_type", this.file); // Append the file to the FormData
      }

      REQUEST_DATA.append("start_date", this.data.publish_start_date);
      REQUEST_DATA.append("end_date", this.data.publish_end_date);
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      if (this.data.region) {
        REQUEST_DATA.append("region_id", this.data.region.id);
      }

      // Append Link Data
      if (this.data.linkType) {
        if (this.data.linkType.id === "external" && this.data.externalUrl) {
          REQUEST_DATA.append("url", this.data.externalUrl);
          REQUEST_DATA.append("url_type", "external_link");
        } else if (
          this.data.linkType.id === "internal" &&
          this.data.urlType &&
          this.data.selectedItem
        ) {
          REQUEST_DATA.append("id", this.data.selectedItem.id);
          REQUEST_DATA.append("url_type", this.data.urlType.id);
        }
      }
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `advertisements`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/ads/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    this.getRegions();
    // End:: Fire Methods
  },
};
</script>
